import { OrderDetail } from '@insurance/api/requests'
import { createContext, useContext } from 'react'

type HealthInsuranceValues = {
  isEditable: boolean
  order?: OrderDetail
}

const HealthInsuranceContext = createContext<HealthInsuranceValues>({
  isEditable: false
})

export const HealthInsuranceProvider = ({
  children,
  ...values
}: React.PropsWithChildren<HealthInsuranceValues>) => {
  return (
    <HealthInsuranceContext.Provider value={values}>
      {children}
    </HealthInsuranceContext.Provider>
  )
}

export const useHealthInsuranceValues = () => useContext(HealthInsuranceContext)
